import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { submitSurveyForApproval } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

export const useSubmitSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, notes }: { id: string; notes?: string }) =>
      submitSurveyForApproval(id, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
      toast.success('Pesquisa enviada para aprovação');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível enviar para aprovação', error);
    },
  });
};
